import React from 'react';
import { chakra } from '@chakra-ui/react';

type Props = {
  size?: number;
  fill?: string;
};

export const HeaderMenuIcon = ({ size = 6, fill = '#D7D7D7' }: Props) => (
  <chakra.svg
    xmlns="http://www.w3.org/2000/svg" 
    width={size}
    height={size}
    viewBox="0 0 24 24" 
    fill="none"
  >
    <path d="M3 4H21V6H3V4ZM9 11H21V13H9V11ZM3 18H21V20H3V18Z" fill={fill} />
  </chakra.svg>
);

export const HeaderMenuCloseIcon = ({ size = 6, fill = '#D7D7D7' }: Props) => (
  <chakra.svg
    xmlns="http://www.w3.org/2000/svg" 
    width={size}
    height={size}
    viewBox="0 0 24 24" 
    fill="none"
  >
    <path d="M12 9.75L18.75 3L21 5.25L14.25 12L21 18.75L18.75 21L12 14.25L5.25 21L3 18.75L9.75 12L3 5.25L5.25 3L12 9.75Z" fill={fill}/>
  </chakra.svg>
)
